import { SystemCurrency, ExchangeRateName } from '@okletsplay/core';

export const OKLP_USDT_PAIR = ExchangeRateName.OKLP_USDT;
export const USDT_OKLP_PAIR = ExchangeRateName.USDT_OKLP;

export const DEFAULT_PAIR = OKLP_USDT_PAIR;

export const PAIRS_TOGGLE = {
  [OKLP_USDT_PAIR]: USDT_OKLP_PAIR,
  [USDT_OKLP_PAIR]: OKLP_USDT_PAIR,
  [ExchangeRateName.OKLP_USD]: OKLP_USDT_PAIR, // For consistency of ExchangeRateName enum
  [ExchangeRateName.USDT_USDT]: ExchangeRateName.USDT_USDT, // For consistency of ExchangeRateName enum
};

export const FORMATTED_PAIRS = {
  [OKLP_USDT_PAIR]: `From ${SystemCurrency.USDT} to ${SystemCurrency.OKLP}`,
  [USDT_OKLP_PAIR]: `From ${SystemCurrency.OKLP} to ${SystemCurrency.USDT}`,
  [ExchangeRateName.OKLP_USD]: `From USD to ${SystemCurrency.OKLP}`, // For consistency of ExchangeRateName enum
  [ExchangeRateName.USDT_USDT]: `From ${SystemCurrency.USDT} to ${SystemCurrency.USDT}`, // For consistency of ExchangeRateName enum
};
